export const RAILZ_PRIMARY_COLOR = '#1D1F48';
export const RAILZ_TEXT_COLOR = '#015b7e';
export const RAILZ_CHART_LEGEND_COLOR = '#424242';
export const RAILZ_CHART_LABEL_COLOR = '#424242';
export const RAILZ_TOOLTIP_COLOR = '#9E9E9E';

export const RAILZ_BALANCE_SHEET_COLORS = ['#009775', '#FD8D62', '#4BCD3E', '#B30000', '#000000'];
export const RAILZ_INCOME_STATEMENT_COLORS = [
  '#B30000',
  '#000000',
  '#FD8D62',
  '#009775',
  '#38C076',
  '#1B1B6F',
];
export const RAILZ_CASHFLOW_COLORS = ['#015B7E', '#F06C3A', '#000000', '#1B1B6F'];
export const RAILZ_STATEMENTS_COLORS = ['#FFED8C', '#F5F5F5'];
export const RAILZ_PIE_COLORS = ['#015B7E', '#3BCFF0', '#009775', '#1B1B6F', '#FFED8C'];
